import { FC, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useControlBarrier } from "../../hooks/useControlBarrier";
import { RoutesMap } from "../../types";
import { CustomForm } from "../../components/common/CustomForm/CustomForm";
import { ApiStatus } from "../../types/api/status";
import { CustomBackdrop } from "../../components/common/CustomBackdrop/CustomBackdrop";
import { CustomFormHeader } from "../../components/common/CustomForm/CustomFormHeader";
import { CustomFormBody } from "../../components/common/CustomForm/CustomFormBody";
import { Formik } from "formik";
import { Autocomplete, Divider, FormLabel, Grid, MenuItem, Select, TextField, Checkbox } from "@mui/material";
import { CustomFormFooter } from "../../components/common/CustomForm/CustomFormFooter";
import { useMainStagesWorksStore } from "../../hooks/useMainStagesWorks";
import { MainStageWork } from "../../types/slices/mainStagesWorksType";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import CheckBoxIcon from '@mui/icons-material/CheckBox'

type FormData = {
    control: string;
}

const ControlBarrierForm: FC = () => {
    const navigate = useNavigate()
    const { status, selectedControlBarrier, createControlBarrierStore, editControlBarrierStore } = useControlBarrier();
    const { mainStagesWorks, getMainStagesWorks } = useMainStagesWorksStore();

    const [isEdit, setIsEdit] = useState<boolean>(false)
    const [data, setData] = useState<FormData>({
        control: ''
    })
    const [selectedMainStages, setSelectedMainStages] = useState<MainStageWork[]>([])
    const [loading, setLoading] = useState<boolean>(false)

    useEffect(() => {
        getMainStageWorksApi()
        if (Object.entries(selectedControlBarrier).length > 0) {
            setIsEdit(true)
            setData({
                control: selectedControlBarrier.control
            })
        }
    }, []);

    useEffect(() => {
        if (Object.entries(selectedControlBarrier).length > 0 && mainStagesWorks.length > 0) {
            const mains = mainStagesWorks.filter(main => selectedControlBarrier.idsmain_stages_work.includes(main.id))
            setSelectedMainStages(mains || [])
        }
    },[mainStagesWorks])

    const getMainStageWorksApi = async () => {
        try {
            setLoading(true)
            await getMainStagesWorks()
            setLoading(false)
        } catch (error) {
            console.log(error);
        }
    }

    const validateForm = (values) => {
        let errors: any = {};
        if (!values.control) errors.control = "El control es requerido";
        return errors;
    }

    const onSubmit = async (values) => {
        const a_idmain_stages_work = selectedMainStages.map(main => main.id)

        const payload = {
            control: values.control,
            a_idmain_stages_work: a_idmain_stages_work
        }
        
        const method = !isEdit ? createControlBarrierStore(payload) : editControlBarrierStore(selectedControlBarrier.id, payload)
        const response = await method
        if (response === true) {
            navigate({ pathname: RoutesMap.CONTROL_BARRIER })
        }
    }

    const onCancel = async () => {
        navigate({ pathname: RoutesMap.CONTROL_BARRIER })
    }
    return (
        <CustomForm>
            {loading && <CustomBackdrop open={true} />}
            {status === ApiStatus.FETCHING && <CustomBackdrop open={true} />}
            <CustomFormHeader
                title={!isEdit ? 'Nuevo Control/Barrera' : 'Editar Control/Barrera'}
                text={!isEdit ? 'Ingrese los datos del nuevo Control/Barrera' : 'Ingrese los datos del Control/Barrera'}
                goBack={RoutesMap.CONTROL_BARRIER}
            />
            <CustomFormBody>
                <Formik initialValues={data} enableReinitialize validate={(values) => validateForm(values)} onSubmit={onSubmit}>
                    {({ values, errors, touched, handleSubmit, handleChange, setFieldValue }) => {
                        return (
                            <form onSubmit={handleSubmit}>
                                <Grid container sx={{ padding: '20px' }}>
                                    <Grid item container xs={12} spacing={2}>
                                        <Grid item xs={12} md={12}>
                                            <FormLabel>Control:</FormLabel>
                                            <TextField
                                                id="control"
                                                type="text"
                                                name="control"
                                                fullWidth
                                                size="small"
                                                value={values.control}
                                                onChange={handleChange}
                                                error={errors.control && touched.control ? true : false}
                                                helperText={errors.control && touched.control ? errors.control : ''}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <FormLabel>Etapa principal de trabajo asociada:</FormLabel>
                                            <Autocomplete
                                                multiple
                                                disablePortal
                                                id="combo-box-work-dones"
                                                value={selectedMainStages || []}
                                                options={mainStagesWorks || []}
                                                getOptionLabel={(option) => option?.actions || ""}
                                                fullWidth
                                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                                renderInput={
                                                    (params) => <TextField {...params} size="small" />
                                                }
                                                onChange={(e, newValue) => {
                                                    setSelectedMainStages(newValue);
                                                }}
                                                renderOption={(props, option, { selected }) => (
                                                    <li key={option.id} value={option.id} {...props} >
                                                        <Checkbox
                                                            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                                            checkedIcon={<CheckBoxIcon fontSize="small" />}
                                                            checked={selected}
                                                        />
                                                        {option.actions}
                                                    </li>
                                                )}
                                                filterSelectedOptions
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Divider />
                                <CustomFormFooter
                                    buttonType="submit"
                                    confirmText={!isEdit ? 'Guardar' : 'Actualizar'}
                                    cancelText={"Cancelar"}
                                    onConfirm={handleSubmit}
                                    onCancel={onCancel}
                                />
                            </form>
                        )
                    }}
                </Formik>
            </CustomFormBody>
        </CustomForm>
    )
}

export default ControlBarrierForm